import { logUserEvent as userEvent, logAPIEvent as APIEvent, EventLog, BaseEventLog, getAdditionalProperties } from 'fmc-digital-common';
import moment from 'moment';
import { v4 } from 'uuid';

export const logUserEvent = (config: BaseEventLog) => {
    userEvent({
        type: config.type,
        action: config.action,
        description: config.description,
        guid: v4(),
        date: moment().toISOString(),
        loanNumber: config.loanNumber,
        ...config,
        ...getAdditionalProperties('amplify')
    });
    // this function is commented because we are already calling this from above userEvent call
    // logFullStoryEvent(config);
};

export const logApiEvent = (config: EventLog) => {
    APIEvent({
        type: config.type,
        action: config.action,
        description: config.description,
        guid: v4(),
        date: moment().toISOString(),
        loanNumber: config.loanNumber,
        request: config.request,
        response: config.response,
        responseTime: config.responseTime,
        success: config.success,
        apiName: config.apiName,
        correlationId: config.correlationId,
        timestamp: config.timestamp,
        error: config.error,
        ...getAdditionalProperties('amplify')
    });
};
